import React, { useState, KeyboardEvent } from 'react';

export interface FlipCardProps {
  front: React.ReactNode;
  back: React.ReactNode;
  ariaLabel: string;
  className?: string;
}

const FlipCard: React.FC<FlipCardProps> = ({ front, back, ariaLabel, className }) => {
  const [isFlipped, setIsFlipped] = useState<boolean>(false);

  const toggle = () => setIsFlipped((prev) => !prev);

  const handleKeyDown = (e: KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      toggle();
    }
  };

  return (
    <div
      className={`flip-card${isFlipped ? ' is-flipped' : ''}${className ? ' ' + className : ''}`}
      role="button"
      tabIndex={0}
      aria-label={ariaLabel}
      aria-pressed={isFlipped}
      onClick={toggle}
      onKeyDown={handleKeyDown}
    >
      <div className="flip-card-inner">
        <div className="flip-card-front" aria-hidden={isFlipped}>
          {front}
        </div>
        <div className="flip-card-back" aria-hidden={!isFlipped}>
          {back}
        </div>
      </div>
    </div>
  );
};

export default FlipCard;
